import { TaxDto } from './models/TaxDto';

/**
 * Appends a "(deleted)" marker to the description of any deactivated tax so users can tell, in the
 * edit/details dropdowns, that an applied tax no longer exists. Active taxes are returned unchanged.
 * `deletedLabel` should already be localized (e.g. t('common.deleted')).
 */
export function markDeletedTaxes (taxes: TaxDto[], deletedLabel: string): TaxDto[] {
    return taxes.map(tax => tax.active === false
        ? { ...tax, description: `${tax.description ?? ''} (${deletedLabel})` }
        : tax);
}
